import { IPeerGroupsProps, getPeerGroupData, IFilter } from "app/components/visualizations/PeerGroups/lib/http";
import * as React from 'react'
import { Panel, Row, Col } from "react-bootstrap";
import { ExpensesAsPercentOfAssets } from "app/components/visualizations/PeerGroups/Expenses/ExpensesAsPercentOfAssets";
import { PerOneMillion } from "app/components/visualizations/PeerGroups/Expenses/PerOneMillion";
import { ExpenseComparison } from "app/components/visualizations/PeerGroups/Expenses/ExpenseComparison";
import { TabHeader } from "app/components/tabs/header";

interface IInvestmentExpenseState {
  data: any[]
  currentPeerGroup: any
  filters: IFilter
}

export class InvestmentExpense extends React.Component<IPeerGroupsProps, IInvestmentExpenseState> {
  state: IInvestmentExpenseState = {
    data: [],
    currentPeerGroup: [],
    filters: { assetLevel: 0 },
  }

  componentDidMount() {
    this.pullData(this.props.filters)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.filters.assetLevel !== this.props.filters.assetLevel) {
      this.setState({ filters: this.props.filters }, () => {
        this.pullData(this.props.filters)
      })
    }
  }

  pullData(filters: IFilter) {
    const requestBody = { action: 'getInvestmentExpenseTab', request: { assetLevel: filters.assetLevel } }
    getPeerGroupData(requestBody)
      .then((response: any[]) => {
        const currentPeerGroup = response.find((dataPoint) => dataPoint.filterId === this.props.filters.assetLevel)
        this.setState({ data: response, currentPeerGroup })
      })
  }

  updateAssetLevelByName(category: string) {
    if (this.props.onChange) {
      this.props.onChange(category)
    }
  }

  updateAssetLevelById(filterId: number) {
    if (this.props.onChangeFilterId) {
      this.props.onChangeFilterId(filterId)
    }
  }

  render() {
    const { assetLevel, assetName } = this.props.filters
    const { currentPeerGroup, data } = this.state
    return (
      <div>
        <TabHeader filters={{ assetLevel, assetName }} label="Investment Expenses" />
        <Panel style={{ marginTop: '10px' }}>
          <Row className="text-center">
            <Col sm={12} md={6}>
              <h4>Disclosed Investment Expenses&#42;</h4>
              <h4 className="text-primary">{currentPeerGroup && currentPeerGroup.InvOver_T_B_TotInvExp}</h4>
            </Col>
            <Col sm={12} md={6} className="fontSize1_7">
              <p>{currentPeerGroup && currentPeerGroup.InvExp_T_B_TotInvExp}</p>
            </Col>
          </Row>
          <Row>
            <Col sm={12} className="text-center fontSize1_7">
              <p>{currentPeerGroup && currentPeerGroup.InvExp_T_B_MdnInvExp}</p>
            </Col>
          </Row>
          <Row>
            <Col sm={12} md={6}>
              <ExpensesAsPercentOfAssets filters={{ assetLevel, assetName }} data={data} onChangeFilterId={filterId => this.updateAssetLevelById(filterId)} />
            </Col>
            <Col sm={12} md={6}>
              <PerOneMillion filters={{ assetLevel, assetName }} data={data} onChangeFilterId={filterId => this.updateAssetLevelById(filterId)} />
            </Col>
          </Row>
          <Row>
            <Col sm={12} md={4} className="fontSize1_7" style={{ padding: '35px' }}>
              <p>{currentPeerGroup && currentPeerGroup.InvExp_T_B_InvExpBpsExample}</p>
              <p>{currentPeerGroup && currentPeerGroup.InvExp_T_B_InvExpCompare2}</p>
            </Col>
            <Col sm={12} md={8}>
              <ExpenseComparison filters={{ assetLevel, assetName }} data={data} currentPeerGroup={currentPeerGroup} />
            </Col>
          </Row>
          <Row>
            <Col sm={12} style={{ padding: '35px' }}>
              <p><small><i>{currentPeerGroup && currentPeerGroup.InvExp_T_B_InvExpFootnote1}</i></small></p>
              <p><small><i>{currentPeerGroup && currentPeerGroup.InvExp_T_B_InvExpFootnote2}</i></small></p>
            </Col>
          </Row>
        </Panel>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/app/containers/PeerGroups/tabs/InvestmentExpense.tsx